<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'app',
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.switch-filed .el-form-item .el-form-item__label{
    width: 180px;
}
.add-new-line{
    text-align: right;
    margin-top: 20px;
}
.add-new-line .u-add-tile-btn {
    display: inline-block;
    height: 24px;
    line-height: 24px;
    min-width: 80px;
    padding: 0 1px;
    text-align: center;
    border-radius: 12px;
    color: #ffffff;
    font-size: 12px;
    font-weight: bold;
    cursor: pointer;
    background: -webkit-gradient(linear, right top, left top, from(#00cf88), to(#09e160));
    background: linear-gradient(-90deg, #00cf88, #09e160);
}
.el-icon-delete{
    color: #FA5050;
    font-size: 20px;
    cursor: pointer;
}
.common-dialog .el-dialog__body .con-filed{
    padding: 0;
}
.common-dialog .el-dialog__body{
    padding-top: 0;
    padding-bottom: 0;
}
.dialog-footer.txt-center{
    text-align: center;
}
.txt-right{
    text-align: right;
}
</style>
